import axios from "axios";

import { setUser } from "../actions/user";
import { get } from "../utils/barrels/lodash";
import { reloadUser } from "../utils/functions";

import { axiosInstance } from "./apiInstance";
import urls from "./urls.json";

const successStatus = [200, 201, 204];
export const getDeliveryPartnerCftFactors = (clientId) => (dispatch) =>
	axiosInstance
		.get(urls.getDeliveryPartnerCFT, {
			params: {
				client_id: clientId,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const generateSignedUrl = (
	fileName,
	fileType,
	url = "uploads/files/"
) => {
	const obj = {
		key: `${url}${fileName}`,
		file_type: fileType,
	};
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.commonFileUploadURL, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const uploadFiletoS3 = (file, s3Path, fields) => {
	const formData = new FormData();
	Object.keys(fields).forEach((key) => {
		formData.append(key, fields[key]);
	});
	formData.append("file", file);
	return (dispatch) =>
		axios
			.post(s3Path, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (successStatus.includes(response.status)) {
					return true;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const updateUserTnCStatus = (clientId, obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.put(`/users/client/${clientId}/`, body)
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const updateUser = (clientId, obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.patch(`/users/client/${clientId}/`, body)
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

let _generateLoggerCache = null;
const getGenerateLogger = async () => {
	if (!_generateLoggerCache) {
		const loggerModule = await import("./logger");
		_generateLoggerCache = loggerModule.generateLogger;
	}
	return _generateLoggerCache;
};

export const generateLogger = (msg, waybill_no) => async (dispatch) => {
	const generateLoggerFn = await getGenerateLogger();
	const loggerThunk = generateLoggerFn(msg, waybill_no, axiosInstance);
	return loggerThunk(dispatch);
};

export const getFeatureTooltip = (featureName) => (dispatch) =>
	axiosInstance
		.get(urls.getFeatureTooltip, {
			params: {
				feature_name: featureName,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 200 || response.status === 201) {
				return response.data;
			} else {
				const err = new Error(
					response.data.msg || "Failed to fetch feature tooltip"
				);
				throw err;
			}
		});

export const dismissFeatureTooltip = (featureName) => (dispatch) => {
	const body = JSON.stringify({
		feature_name: featureName,
	});
	return axiosInstance
		.post(urls.getFeatureTooltip, body)
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "post",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 200 || response.status === 201) {
				return response.data;
			} else {
				const err = new Error(
					response.data.msg || "Failed to dismiss feature tooltip"
				);
				throw err;
			}
		});
};
